// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AvailableStock_wrapper__3pDcj","forwardbtn":"AvailableStock_forwardbtn__1a1XL"};